import React, { useState, forwardRef } from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Lock, FileText, Zap, Star, CheckSquare, Square } from 'lucide-react';
import { trackAddToCart } from '../lib/meta-pixel';
import { motion } from 'framer-motion';
const BASE_PRICE = 6.39;
const BUMP_PRICE = 4.95;
export const PricingSection = forwardRef<HTMLElement>((props, ref) => {
  const [bump1Checked, setBump1Checked] = useState(false);
  const [bump2Checked, setBump2Checked] = useState(false);
  const totalPrice = BASE_PRICE + (bump1Checked ? BUMP_PRICE : 0) + (bump2Checked ? BUMP_PRICE : 0);
  const formattedTotal = totalPrice.toFixed(2);
  const getCheckoutUrl = () => {
    if (bump1Checked && bump2Checked) {
      return 'https://www.nachogerberg.com/cart/42713119490119:1';
    }
    if (bump1Checked) {
      return 'https://www.nachogerberg.com/cart/42713117032519:1';
    }
    if (bump2Checked) {
      return 'https://www.nachogerberg.com/cart/42713117622343:1';
    }
    return 'https://www.nachogerberg.com/cart/42710498476103:1';
  };
  return <section ref={ref} className="py-6 md:py-24 bg-stone-950 px-3 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-312">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-600/10 blur-[120px] rounded-full pointer-events-none" data-id="element-313" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-314">
        <FadeIn data-id="element-315">
          <div className="bg-stone-900 border border-amber-500/30 rounded-2xl p-4 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-316">
            {/* Top accent line */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 via-orange-400 to-amber-500" data-id="element-317" />

            <div className="text-center mb-4 md:mb-10" data-id="element-318">
              <h2 className="text-2xl md:text-5xl font-bold text-white mb-1 md:mb-4" data-id="element-319">
                Todo esto por{' '}
                <span className="text-amber-500" data-id="element-320">${formattedTotal}</span>.
              </h2>
            </div>

            <div className="bg-stone-950 rounded-xl p-3 md:p-8 mb-4 md:mb-10 border border-stone-800" data-id="element-321">
              <h3 className="text-base md:text-xl font-bold text-white mb-3 md:mb-6 border-b border-stone-800 pb-2 md:pb-4" data-id="element-322">
                Lo que te llevas:
              </h3>
              <ul className="space-y-3 md:space-y-6" data-id="element-323">
                <li className="flex items-start gap-2 md:gap-4 text-stone-200" data-id="element-324">
                  <img src="https://cdn.magicpatterns.com/uploads/4e7Y8xZzsUzCFT6eNbfD2g/ChatGPT_Image_18_abr_2026,_17_52_08.png" alt="eBook Mente en Blanco" className="w-10 h-12 md:w-20 md:h-24 object-cover rounded-lg border border-stone-700 shadow-md shrink-0" data-id="element-325" />
                  <div data-id="element-326">
                    <div className="flex items-center gap-1.5 md:gap-2 mb-0.5" data-id="element-327">
                      <span className="text-emerald-500 text-xs md:text-base" data-id="element-328">
                        ✅
                      </span>
                      <span className="font-semibold text-white text-xs md:text-base leading-tight" data-id="element-329">
                        eBook — Mente en Blanco en 5 Minutos
                      </span>
                    </div>
                    <p className="text-stone-400 text-[11px] md:text-sm leading-tight" data-id="element-330">
                      El protocolo completo de Vaciado Clínico para cortar la
                      rumiación nocturna
                    </p>
                    <span className="text-stone-500 text-[11px] md:text-sm" data-id="element-331">
                      — $17
                    </span>
                  </div>
                </li>
                <li className="flex items-start gap-2 md:gap-4 text-stone-200" data-id="element-332">
                  <img src="https://cdn.magicpatterns.com/uploads/o5fruLTcPigRuz58Vvu67A/bono2mapa.png" alt="Mapa de Pensamientos Nocturnos" className="w-10 h-12 md:w-20 md:h-24 object-cover rounded-lg border border-stone-700 shadow-md shrink-0" data-id="element-333" />
                  <div data-id="element-334">
                    <div className="flex items-center gap-1.5 md:gap-2 mb-0.5" data-id="element-335">
                      <span className="text-xs md:text-base" data-id="element-336">🎁</span>
                      <span className="font-semibold text-white text-xs md:text-base leading-tight" data-id="element-337">
                        Bono #1 — Mapa de Pensamientos Nocturnos
                      </span>
                    </div>
                    <p className="text-stone-400 text-[11px] md:text-sm leading-tight" data-id="element-338">
                      El mapa para saber qué tipo de pensamiento tienes y cómo
                      responderle
                    </p>
                    <div className="mt-0.5" data-id="element-339">
                      <span className="text-stone-500 line-through text-[11px] md:text-sm" data-id="element-340">
                        — $13
                      </span>
                      <span className="ml-1.5 text-emerald-500 font-bold text-[11px] md:text-sm" data-id="element-341">
                        GRATIS
                      </span>
                    </div>
                  </div>
                </li>
              </ul>

              <div className="mt-4 md:mt-8 pt-3 md:pt-6 border-t border-stone-800 flex flex-col gap-3 md:gap-4" data-id="element-342">
                <div className="flex flex-col sm:flex-row justify-between items-center gap-2 md:gap-4" data-id="element-343">
                  <div className="text-stone-400 text-sm md:text-lg" data-id="element-344">
                    Valor total: <span className="line-through" data-id="element-345">$30 USD</span>
                  </div>
                  <div className="text-lg md:text-2xl text-white font-bold" data-id="element-346">
                    Precio hoy:{' '}
                    <motion.span key={formattedTotal} initial={{
                    scale: 1.2,
                    color: '#f59e0b'
                  }} animate={{
                    scale: 1,
                    color: '#f59e0b'
                  }} transition={{
                    duration: 0.3
                  }} className="text-amber-500 text-2xl md:text-4xl font-black" data-id="element-347">
                      ${formattedTotal} USD
                    </motion.span>
                  </div>
                </div>

                {(bump1Checked || bump2Checked) && <motion.div initial={{
                opacity: 0,
                height: 0
              }} animate={{
                opacity: 1,
                height: 'auto'
              }} transition={{
                duration: 0.3
              }} className="bg-amber-500/5 border border-amber-500/20 rounded-lg p-2.5 md:p-4" data-id="element-348">
                    <p className="text-stone-400 text-[11px] md:text-xs font-medium uppercase tracking-wider mb-1.5 md:mb-2" data-id="element-349">
                      Añadido a tu orden:
                    </p>
                    <ul className="space-y-1 md:space-y-1.5" data-id="element-350">
                      {bump1Checked && <motion.li initial={{
                    opacity: 0,
                    x: -10
                  }} animate={{
                    opacity: 1,
                    x: 0
                  }} className="flex items-center gap-1.5 md:gap-2 text-white text-xs md:text-sm" data-id="element-351">
                          <span className="text-amber-500" data-id="element-352">✓</span>
                          <span data-id="element-353">El Protocolo Ciego</span>
                          <span className="text-amber-400 font-semibold ml-auto" data-id="element-354">
                            +$4.95
                          </span>
                        </motion.li>}
                      {bump2Checked && <motion.li initial={{
                    opacity: 0,
                    x: -10
                  }} animate={{
                    opacity: 1,
                    x: 0
                  }} className="flex items-center gap-1.5 md:gap-2 text-white text-xs md:text-sm" data-id="element-355">
                          <span className="text-amber-500" data-id="element-356">✓</span>
                          <span data-id="element-357">Bitácora de 365 Noches</span>
                          <span className="text-amber-400 font-semibold ml-auto" data-id="element-358">
                            +$4.95
                          </span>
                        </motion.li>}
                    </ul>
                  </motion.div>}
              </div>

              <div className="mt-4 md:mt-6 text-center" data-id="element-359">
                <a href={getCheckoutUrl()} target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="w-full sm:w-auto inline-block" data-id="element-360">
                  <Button size="lg" className="w-full sm:w-auto bg-amber-600 hover:bg-amber-700 text-white text-sm md:text-xl px-6 md:px-12 py-4 md:py-8 h-auto rounded-full shadow-[0_0_40px_-10px_rgba(217,119,6,0.5)] transition-all hover:shadow-[0_0_60px_-15px_rgba(217,119,6,0.7)] hover:scale-105" data-id="element-361">
                    Sí, Quiero el protocolo completo por ${formattedTotal}
                  </Button>
                </a>
              </div>
            </div>

            <div className="flex flex-col items-center" data-id="element-362">
              {/* ORDER BUMP #1 - El Protocolo Ciego */}
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.4
            }} className="w-full max-w-2xl mb-3 md:mb-4" data-id="element-363">
                <div className={`relative border-2 rounded-xl overflow-hidden transition-all duration-300 cursor-pointer ${bump1Checked ? 'border-amber-500 bg-amber-500/5' : 'border-dashed border-amber-500/50 bg-stone-950/80'}`} onClick={() => setBump1Checked(!bump1Checked)} data-id="element-364">
                  {/* Altamente Recomendado Badge */}
                  <div className="bg-gradient-to-r from-amber-500 to-orange-500 px-3 py-1.5 md:py-2 flex items-center justify-center gap-1.5" data-id="element-365">
                    <Star className="w-3 h-3 md:w-4 md:h-4 text-white fill-white" data-id="element-366" />
                    <span className="text-white font-bold text-[11px] md:text-sm uppercase tracking-wider" data-id="element-367">
                      Altamente Recomendado
                    </span>
                    <Star className="w-3 h-3 md:w-4 md:h-4 text-white fill-white" data-id="element-368" />
                  </div>

                  <div className="p-3 md:p-5" data-id="element-369">
                    <div className="flex items-start gap-2 md:gap-4" data-id="element-370">
                      <div className="shrink-0 mt-0.5" data-id="element-371">
                        {bump1Checked ? <CheckSquare className="w-5 h-5 md:w-6 md:h-6 text-amber-500" data-id="element-372" /> : <Square className="w-5 h-5 md:w-6 md:h-6 text-amber-500/60" data-id="element-373" />}
                      </div>
                      <div className="flex-1" data-id="element-374">
                        <div className="flex items-start gap-3 md:gap-4 mb-2 md:mb-3" data-id="element-375">
                          <img src="https://cdn.magicpatterns.com/uploads/fLcTVuE2Tkd4R8EvkC5dkY/portada_protocolo_ciego.png" alt="Protocolo Ciego" className="w-14 h-16 md:w-20 md:h-24 object-cover rounded-lg border border-stone-700 shadow-md shrink-0" data-id="element-376" />
                          <div data-id="element-377">
                            <h4 className="text-white font-bold text-sm md:text-lg mb-1 leading-tight" data-id="element-378">
                              ¿Demasiado agotado para escribir? Activa el
                              "Interruptor Ciego" 🌑
                            </h4>
                          </div>
                        </div>
                        <p className="text-stone-400 text-[11px] md:text-sm leading-relaxed mb-2 md:mb-3" data-id="element-379">
                          Es una técnica de vaciado mental por visualización que
                          no requiere papel, ni luz, ni esfuerzo físico.
                          Aprenderás a mover tus pensamientos a 'Cajas de
                          Cierre' mentales mientras estás acostado y con los
                          ojos cerrados. Es el plan de emergencia perfecto para
                          cuando tu cerebro no se apaga, pero tu cuerpo ya no
                          quiere moverse.
                        </p>
                        <div className="flex items-center gap-2 flex-wrap" data-id="element-380">
                          <span className="text-amber-400 font-bold text-sm md:text-base" data-id="element-381">
                            Sí, quiero añadir el Protocolo Ciego por solo $4.95
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* ORDER BUMP #2 - La Bitácora de 365 Noches */}
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.4,
              delay: 0.1
            }} className="w-full max-w-2xl mb-4 md:mb-8" data-id="element-382">
                <div className={`relative border-2 rounded-xl overflow-hidden transition-all duration-300 cursor-pointer ${bump2Checked ? 'border-amber-500 bg-amber-500/5' : 'border-dashed border-amber-500/50 bg-stone-950/80'}`} onClick={() => setBump2Checked(!bump2Checked)} data-id="element-383">
                  {/* Altamente Recomendado Badge */}
                  <div className="bg-gradient-to-r from-amber-500 to-orange-500 px-3 py-1.5 md:py-2 flex items-center justify-center gap-1.5" data-id="element-384">
                    <Star className="w-3 h-3 md:w-4 md:h-4 text-white fill-white" data-id="element-385" />
                    <span className="text-white font-bold text-[11px] md:text-sm uppercase tracking-wider" data-id="element-386">
                      Altamente Recomendado
                    </span>
                    <Star className="w-3 h-3 md:w-4 md:h-4 text-white fill-white" data-id="element-387" />
                  </div>

                  <div className="p-3 md:p-5" data-id="element-388">
                    <div className="flex items-start gap-2 md:gap-4" data-id="element-389">
                      <div className="shrink-0 mt-0.5" data-id="element-390">
                        {bump2Checked ? <CheckSquare className="w-5 h-5 md:w-6 md:h-6 text-amber-500" data-id="element-391" /> : <Square className="w-5 h-5 md:w-6 md:h-6 text-amber-500/60" data-id="element-392" />}
                      </div>
                      <div className="flex-1" data-id="element-393">
                        <div className="flex items-start gap-3 md:gap-4 mb-2 md:mb-3" data-id="element-394">
                          <img src="https://cdn.magicpatterns.com/uploads/4ERdQjPUQ9U56JB2riHSYD/portada_bitacora.png" alt="Bitácora de Descompresión 365 Noches" className="w-14 h-16 md:w-20 md:h-24 object-cover rounded-lg border border-stone-700 shadow-md shrink-0" data-id="element-395" />
                          <div data-id="element-396">
                            <h4 className="text-white font-bold text-sm md:text-lg mb-1 leading-tight" data-id="element-397">
                              Hazlo Automático: Tu Bitácora Digital de
                              Descompresión Mental (365 días) 📑
                            </h4>
                          </div>
                        </div>
                        <p className="text-stone-400 text-[11px] md:text-sm leading-relaxed mb-2 md:mb-3" data-id="element-398">
                          Recibirás un set de plantillas digitales
                          (interactivas) e imprimibles con el diseño clínico
                          exacto para que solo tengas que 'llenar los espacios'.
                          Incluye secciones de categorización de amenazas y
                          trackers de progreso mensual para que veas cómo tu
                          ansiedad disminuye noche tras noche. No busques más
                          hojas sueltas; ten un lugar profesional donde
                          depositar tu ruido mental durante todo un año.
                        </p>
                        <div className="flex items-center gap-2 flex-wrap" data-id="element-399">
                          <span className="text-amber-400 font-bold text-sm md:text-base" data-id="element-400">
                            Sí, añadir mi Bitácora Anual por solo $4.95
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>

              <a href={getCheckoutUrl()} target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="w-full sm:w-auto" data-id="element-401">
                <Button size="lg" className="w-full sm:w-auto bg-amber-600 hover:bg-amber-700 text-white text-sm md:text-xl px-6 md:px-12 py-4 md:py-8 h-auto rounded-full shadow-[0_0_40px_-10px_rgba(217,119,6,0.5)] transition-all hover:shadow-[0_0_60px_-15px_rgba(217,119,6,0.7)] hover:scale-105 mb-3 md:mb-6" data-id="element-402">
                  Sí, Quiero el protocolo completo por ${formattedTotal}
                </Button>
              </a>

              <div className="flex flex-row items-center justify-center gap-3 md:gap-6 text-[11px] md:text-sm text-stone-500 mb-3 md:mb-8" data-id="element-403">
                <div className="flex items-center gap-1 md:gap-2" data-id="element-404">
                  <Lock className="w-3 h-3 md:w-4 md:h-4" data-id="element-405" />
                  <span data-id="element-406">Pago Seguro</span>
                </div>
                <div className="flex items-center gap-1 md:gap-2" data-id="element-407">
                  <FileText className="w-3 h-3 md:w-4 md:h-4" data-id="element-408" />
                  <span data-id="element-409">PDF Instantáneo</span>
                </div>
                <div className="flex items-center gap-1 md:gap-2" data-id="element-410">
                  <Zap className="w-3 h-3 md:w-4 md:h-4" data-id="element-411" />
                  <span data-id="element-412">Aplica Hoy</span>
                </div>
              </div>

              <div className="bg-stone-950/50 rounded-xl p-3 md:p-6 border border-stone-800/50 max-w-2xl text-center" data-id="element-413">
                <p className="text-stone-400 text-[11px] md:text-sm mb-1.5 md:mb-3" data-id="element-414">
                  Al hacer clic serás redirigido a una página de pago segura.
                  Recibirás los tres recursos en tu correo en minutos.
                </p>
                <p className="text-amber-400/90 font-medium text-xs md:text-base" data-id="element-415">
                  Tu mente ya lleva demasiadas noches sin cerrar sesión. Esta
                  puede ser la primera en que sí lo haga.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
});
PricingSection.displayName = 'PricingSection';